const {DATA_TYPES, NAMESPACE_MAPPING} = require('@wix/document-services-json-schemas').namespaceMapping
const dataUtils = require('../../../helpers/dataUtils')
const {
    migrateMegaMenuContainerItemDesign,
    migrateMegaMenuContainerItemLayout,
    DROPDOWN_SKIN,
    megaMenuContainerItemInitialStyleItem
} = require('@wix/component-migration/migrateStylableHorizontalMenuToNewMenu')

/**
 * @param {Object} pageManager
 * @param {Object} component
 * @param {Object} menuStyleItem
 * @param {Array<string>} [variants]
 */
const migrateMegaMenuContainerItem = (pageManager, component, menuStyleItem, variants) => {
    const {components} = component

    if (components.length === 0) return

    components.forEach(megaMenuContainerItemComponent => {
        const componentStyle = migrateToBreakpointsStyleIfNeeded(pageManager, megaMenuContainerItemComponent)
        const styleItemPerBreakpoint = populateStylePerBreakpoint(pageManager)
        const stylableHorizontalMenuProps = pageManager.data.getItem(
            NAMESPACE_MAPPING.props,
            component.propertyQuery.replace('#', '')
        )
        migrateMegaMenuContainerItemLayout(stylableHorizontalMenuProps, menuStyleItem, styleItemPerBreakpoint)
        migrateMegaMenuContainerItemDesign(menuStyleItem, styleItemPerBreakpoint)
        const variantRelationId = populateVariantsRelationIfNeeded(
            pageManager,
            componentStyle.id,
            styleItemPerBreakpoint.id,
            variants
        )
        const styleIdToRefer = variantRelationId ?? styleItemPerBreakpoint.id
        pageManager.data.updateItem(componentStyle.id, NAMESPACE_MAPPING.style, {
            values: [...componentStyle.values, `#${styleIdToRefer}`]
        })
    })
}

/**
 * @param {Object} pageManager
 * @param {Object} component
 */
const migrateToBreakpointsStyleIfNeeded = (pageManager, component) => {
    const initialComponentStyle = pageManager.data.getItem(NAMESPACE_MAPPING.style, component.styleId)
    const isAlreadyBreakpointsStyle = initialComponentStyle.type === 'RefArray'

    if (isAlreadyBreakpointsStyle) return initialComponentStyle

    pageManager.data.removeItem(NAMESPACE_MAPPING.style, initialComponentStyle.id)
    const newComponentStyleId = pageManager.data.addItem(NAMESPACE_MAPPING.style, DATA_TYPES.theme, {
        id: initialComponentStyle.id,
        ...dataUtils.refArray.create()
    })
    const newComponentStyle = pageManager.data.getItem(NAMESPACE_MAPPING.style, newComponentStyleId)
    component.styleId = newComponentStyleId
    component.skin = DROPDOWN_SKIN

    return newComponentStyle
}

/**
 * @param {Object} pageManager
 * @param {string} megaMenuContainerItemId
 * @param {string} styleId
 * @param {Array<string>} variants
 */
const populateVariantsRelationIfNeeded = (pageManager, megaMenuContainerItemId, styleId, variants) => {
    if (!variants) return

    return pageManager.data.addItem(NAMESPACE_MAPPING.style, DATA_TYPES.theme, {
        to: `#${styleId}`,
        from: `#${megaMenuContainerItemId}`,
        type: 'VariantRelation',
        variants
    })
}

/**
 * @param {Object} pageManager
 */
const populateStylePerBreakpoint = pageManager => {
    const styleIdPerBreakpoint = pageManager.data.addItem(
        NAMESPACE_MAPPING.style,
        DATA_TYPES.theme,
        megaMenuContainerItemInitialStyleItem()
    )

    const styleItemPerBreakpoint = pageManager.data.getItem(NAMESPACE_MAPPING.style, styleIdPerBreakpoint)

    return styleItemPerBreakpoint
}

module.exports = {
    migrateMegaMenuContainerItem
}
